import {
  SignalLow,
  SignalMedium,
  SignalZero,
  type LucideProps,
} from 'lucide-react';

type Priority = 'low' | 'medium' | 'high';

const SIGNAL_BY_PRIORITY = {
  high: SignalMedium,
  medium: SignalLow,
  low: SignalZero,
} satisfies Record<Priority, typeof SignalMedium>;

function PrioritySignal({
  priority,
  ...props
}: { priority: Priority } & LucideProps) {
  const Signal = SIGNAL_BY_PRIORITY[priority];

  return <Signal aria-hidden {...props} />;
}

export default PrioritySignal;
